import { ContractConceptCategory } from '../../models/Entities/Contracts/ContractConceptCategory';
import { CommonState } from '../common/state/commonState';

export interface ContractConceptCategoryState extends CommonState<ContractConceptCategory> {
    /** Id de la categoría que se está borrando, para marcar sólo esa fila. */
    deletingId: number | undefined;
}

export const ContractConceptCategoryUnloadState: ContractConceptCategoryState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    deletingId: undefined
};
